module.exports = __webpack_public_path__ + "img/cancel.c8605a53.svg";